import { reapitConnectBrowserSession } from '@reapit-sales/reapit-connect'
import { ReapitConnectSession } from '@reapit/connect-session'

export const refreshSession = async (): Promise<void | ReapitConnectSession> => {
  const accessToken = await reapitConnectBrowserSession.connectSession()
  return accessToken
}
